import styled from "@emotion/styled";
import colors from "styles/colors.js";
import { IRIS_COLOR_NAME } from "styles/color-consts";

export const StyledShortFooterLink = styled.a`
  text-decoration: none;
  cursor: default;
  width: fit-content;
  color: ${colors.black};
  line-height: 12px;
  display: flex;
  gap: 4px;
  transition: 100ms color ease;

  .link-icon {
    height: 12px;
    width: 12px;
  }

  &.main-title {
    font-weight: 600;
    font-size: 0.875rem;

    &.clickable {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  &.secondary-title {
    font-weight: 600;
    color: ${colors.asphalt};
    font-size: 0.75rem;
  }

  &.link {
    font-weight: 400;
    font-size: 0.75rem;
    cursor: pointer;

    &:hover {
      color: ${colors[IRIS_COLOR_NAME]};
    }
  }
`;
